/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CapitalCallsRouteImport } from './routes/capital-calls'
import { Route as CompaniesRouteImport } from './routes/companies'
import { Route as HubRouteImport } from './routes/hub'
import { Route as InvestmentsRouteImport } from './routes/investments'
import { Route as QsbsRouteImport } from './routes/qsbs'
import { Route as RiskFeedRouteImport } from './routes/risk-feed'
import { Route as SixAlphasRouteImport } from './routes/six-alphas'
import { Route as CapitalCallsCallIdRouteImport } from './routes/capital-calls.$callId'
import { Route as CompaniesIndexRouteImport } from './routes/companies.index'
import { Route as HubIndexRouteImport } from './routes/hub.index'
import { Route as HubCommunicationsRouteImport } from './routes/hub.communications'
import { Route as HubDocumentsRouteImport } from './routes/hub.documents'
import { Route as HubIcMeetingsRouteImport } from './routes/hub.ic-meetings'
import { Route as HubTaxDocumentsRouteImport } from './routes/hub.tax-documents'
import { Route as CompaniesIdIndexRouteImport } from './routes/companies.$id.index'
import { Route as CompaniesIdBudgetRouteImport } from './routes/companies.$id.budget'
import { Route as CompaniesIdMilestonesRouteImport } from './routes/companies.$id.milestones'
import { Route as CompaniesIdQsbsRouteImport } from './routes/companies.$id.qsbs'
import { Route as HubCommunicationsSessionRouteImport } from './routes/hub.communications.session'
import { Route as HubCommunicationsSynthesisRouteImport } from './routes/hub.communications.synthesis'
import { Route as HubCommunicationsThreadRouteImport } from './routes/hub.communications.thread'
import { Route as HubIcMeetingsArtifactRouteImport } from './routes/hub.ic-meetings.artifact'
import { Route as HubIcMeetingsNavMarkRouteImport } from './routes/hub.ic-meetings.nav-mark'
import { Route as HubIcMeetingsTemplateRouteImport } from './routes/hub.ic-meetings.template'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CapitalCallsRoute = CapitalCallsRouteImport.update({
  id: '/capital-calls',
  path: '/capital-calls',
  getParentRoute: () => rootRouteImport,
} as any)
const CompaniesRoute = CompaniesRouteImport.update({
  id: '/companies',
  path: '/companies',
  getParentRoute: () => rootRouteImport,
} as any)
const HubRoute = HubRouteImport.update({
  id: '/hub',
  path: '/hub',
  getParentRoute: () => rootRouteImport,
} as any)
const InvestmentsRoute = InvestmentsRouteImport.update({
  id: '/investments',
  path: '/investments',
  getParentRoute: () => rootRouteImport,
} as any)
const QsbsRoute = QsbsRouteImport.update({
  id: '/qsbs',
  path: '/qsbs',
  getParentRoute: () => rootRouteImport,
} as any)
const RiskFeedRoute = RiskFeedRouteImport.update({
  id: '/risk-feed',
  path: '/risk-feed',
  getParentRoute: () => rootRouteImport,
} as any)
const SixAlphasRoute = SixAlphasRouteImport.update({
  id: '/six-alphas',
  path: '/six-alphas',
  getParentRoute: () => rootRouteImport,
} as any)
const CapitalCallsCallIdRoute = CapitalCallsCallIdRouteImport.update({
  id: '/$callId',
  path: '/$callId',
  getParentRoute: () => CapitalCallsRoute,
} as any)
const CompaniesIndexRoute = CompaniesIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CompaniesRoute,
} as any)
const HubIndexRoute = HubIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => HubRoute,
} as any)
const HubCommunicationsRoute = HubCommunicationsRouteImport.update({
  id: '/communications',
  path: '/communications',
  getParentRoute: () => HubRoute,
} as any)
const HubDocumentsRoute = HubDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => HubRoute,
} as any)
const HubIcMeetingsRoute = HubIcMeetingsRouteImport.update({
  id: '/ic-meetings',
  path: '/ic-meetings',
  getParentRoute: () => HubRoute,
} as any)
const HubTaxDocumentsRoute = HubTaxDocumentsRouteImport.update({
  id: '/tax-documents',
  path: '/tax-documents',
  getParentRoute: () => HubRoute,
} as any)
const CompaniesIdIndexRoute = CompaniesIdIndexRouteImport.update({
  id: '/$id/',
  path: '/$id/',
  getParentRoute: () => CompaniesRoute,
} as any)
const CompaniesIdBudgetRoute = CompaniesIdBudgetRouteImport.update({
  id: '/$id/budget',
  path: '/$id/budget',
  getParentRoute: () => CompaniesRoute,
} as any)
const CompaniesIdMilestonesRoute = CompaniesIdMilestonesRouteImport.update({
  id: '/$id/milestones',
  path: '/$id/milestones',
  getParentRoute: () => CompaniesRoute,
} as any)
const CompaniesIdQsbsRoute = CompaniesIdQsbsRouteImport.update({
  id: '/$id/qsbs',
  path: '/$id/qsbs',
  getParentRoute: () => CompaniesRoute,
} as any)
const HubCommunicationsSessionRoute =
  HubCommunicationsSessionRouteImport.update({
    id: '/session',
    path: '/session',
    getParentRoute: () => HubCommunicationsRoute,
  } as any)
const HubCommunicationsSynthesisRoute =
  HubCommunicationsSynthesisRouteImport.update({
    id: '/synthesis',
    path: '/synthesis',
    getParentRoute: () => HubCommunicationsRoute,
  } as any)
const HubCommunicationsThreadRoute = HubCommunicationsThreadRouteImport.update({
  id: '/thread',
  path: '/thread',
  getParentRoute: () => HubCommunicationsRoute,
} as any)
const HubIcMeetingsArtifactRoute = HubIcMeetingsArtifactRouteImport.update({
  id: '/artifact',
  path: '/artifact',
  getParentRoute: () => HubIcMeetingsRoute,
} as any)
const HubIcMeetingsNavMarkRoute = HubIcMeetingsNavMarkRouteImport.update({
  id: '/nav-mark',
  path: '/nav-mark',
  getParentRoute: () => HubIcMeetingsRoute,
} as any)
const HubIcMeetingsTemplateRoute = HubIcMeetingsTemplateRouteImport.update({
  id: '/template',
  path: '/template',
  getParentRoute: () => HubIcMeetingsRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/capital-calls': typeof CapitalCallsRouteWithChildren
  '/companies': typeof CompaniesRouteWithChildren
  '/hub': typeof HubRouteWithChildren
  '/investments': typeof InvestmentsRoute
  '/qsbs': typeof QsbsRoute
  '/risk-feed': typeof RiskFeedRoute
  '/six-alphas': typeof SixAlphasRoute
  '/capital-calls/$callId': typeof CapitalCallsCallIdRoute
  '/hub/communications': typeof HubCommunicationsRouteWithChildren
  '/hub/documents': typeof HubDocumentsRoute
  '/hub/ic-meetings': typeof HubIcMeetingsRouteWithChildren
  '/hub/tax-documents': typeof HubTaxDocumentsRoute
  '/companies/': typeof CompaniesIndexRoute
  '/hub/': typeof HubIndexRoute
  '/companies/$id/budget': typeof CompaniesIdBudgetRoute
  '/companies/$id/milestones': typeof CompaniesIdMilestonesRoute
  '/companies/$id/qsbs': typeof CompaniesIdQsbsRoute
  '/hub/communications/session': typeof HubCommunicationsSessionRoute
  '/hub/communications/synthesis': typeof HubCommunicationsSynthesisRoute
  '/hub/communications/thread': typeof HubCommunicationsThreadRoute
  '/hub/ic-meetings/artifact': typeof HubIcMeetingsArtifactRoute
  '/hub/ic-meetings/nav-mark': typeof HubIcMeetingsNavMarkRoute
  '/hub/ic-meetings/template': typeof HubIcMeetingsTemplateRoute
  '/companies/$id/': typeof CompaniesIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/capital-calls': typeof CapitalCallsRouteWithChildren
  '/investments': typeof InvestmentsRoute
  '/qsbs': typeof QsbsRoute
  '/risk-feed': typeof RiskFeedRoute
  '/six-alphas': typeof SixAlphasRoute
  '/capital-calls/$callId': typeof CapitalCallsCallIdRoute
  '/hub/communications': typeof HubCommunicationsRouteWithChildren
  '/hub/documents': typeof HubDocumentsRoute
  '/hub/ic-meetings': typeof HubIcMeetingsRouteWithChildren
  '/hub/tax-documents': typeof HubTaxDocumentsRoute
  '/companies': typeof CompaniesIndexRoute
  '/hub': typeof HubIndexRoute
  '/companies/$id/budget': typeof CompaniesIdBudgetRoute
  '/companies/$id/milestones': typeof CompaniesIdMilestonesRoute
  '/companies/$id/qsbs': typeof CompaniesIdQsbsRoute
  '/hub/communications/session': typeof HubCommunicationsSessionRoute
  '/hub/communications/synthesis': typeof HubCommunicationsSynthesisRoute
  '/hub/communications/thread': typeof HubCommunicationsThreadRoute
  '/hub/ic-meetings/artifact': typeof HubIcMeetingsArtifactRoute
  '/hub/ic-meetings/nav-mark': typeof HubIcMeetingsNavMarkRoute
  '/hub/ic-meetings/template': typeof HubIcMeetingsTemplateRoute
  '/companies/$id': typeof CompaniesIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/capital-calls': typeof CapitalCallsRouteWithChildren
  '/companies': typeof CompaniesRouteWithChildren
  '/hub': typeof HubRouteWithChildren
  '/investments': typeof InvestmentsRoute
  '/qsbs': typeof QsbsRoute
  '/risk-feed': typeof RiskFeedRoute
  '/six-alphas': typeof SixAlphasRoute
  '/capital-calls/$callId': typeof CapitalCallsCallIdRoute
  '/hub/communications': typeof HubCommunicationsRouteWithChildren
  '/hub/documents': typeof HubDocumentsRoute
  '/hub/ic-meetings': typeof HubIcMeetingsRouteWithChildren
  '/hub/tax-documents': typeof HubTaxDocumentsRoute
  '/companies/': typeof CompaniesIndexRoute
  '/hub/': typeof HubIndexRoute
  '/companies/$id/budget': typeof CompaniesIdBudgetRoute
  '/companies/$id/milestones': typeof CompaniesIdMilestonesRoute
  '/companies/$id/qsbs': typeof CompaniesIdQsbsRoute
  '/hub/communications/session': typeof HubCommunicationsSessionRoute
  '/hub/communications/synthesis': typeof HubCommunicationsSynthesisRoute
  '/hub/communications/thread': typeof HubCommunicationsThreadRoute
  '/hub/ic-meetings/artifact': typeof HubIcMeetingsArtifactRoute
  '/hub/ic-meetings/nav-mark': typeof HubIcMeetingsNavMarkRoute
  '/hub/ic-meetings/template': typeof HubIcMeetingsTemplateRoute
  '/companies/$id/': typeof CompaniesIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/capital-calls'
    | '/companies'
    | '/hub'
    | '/investments'
    | '/qsbs'
    | '/risk-feed'
    | '/six-alphas'
    | '/capital-calls/$callId'
    | '/hub/communications'
    | '/hub/documents'
    | '/hub/ic-meetings'
    | '/hub/tax-documents'
    | '/companies/'
    | '/hub/'
    | '/companies/$id/budget'
    | '/companies/$id/milestones'
    | '/companies/$id/qsbs'
    | '/hub/communications/session'
    | '/hub/communications/synthesis'
    | '/hub/communications/thread'
    | '/hub/ic-meetings/artifact'
    | '/hub/ic-meetings/nav-mark'
    | '/hub/ic-meetings/template'
    | '/companies/$id/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/capital-calls'
    | '/investments'
    | '/qsbs'
    | '/risk-feed'
    | '/six-alphas'
    | '/capital-calls/$callId'
    | '/hub/communications'
    | '/hub/documents'
    | '/hub/ic-meetings'
    | '/hub/tax-documents'
    | '/companies'
    | '/hub'
    | '/companies/$id/budget'
    | '/companies/$id/milestones'
    | '/companies/$id/qsbs'
    | '/hub/communications/session'
    | '/hub/communications/synthesis'
    | '/hub/communications/thread'
    | '/hub/ic-meetings/artifact'
    | '/hub/ic-meetings/nav-mark'
    | '/hub/ic-meetings/template'
    | '/companies/$id'
  id:
    | '__root__'
    | '/'
    | '/capital-calls'
    | '/companies'
    | '/hub'
    | '/investments'
    | '/qsbs'
    | '/risk-feed'
    | '/six-alphas'
    | '/capital-calls/$callId'
    | '/hub/communications'
    | '/hub/documents'
    | '/hub/ic-meetings'
    | '/hub/tax-documents'
    | '/companies/'
    | '/hub/'
    | '/companies/$id/budget'
    | '/companies/$id/milestones'
    | '/companies/$id/qsbs'
    | '/hub/communications/session'
    | '/hub/communications/synthesis'
    | '/hub/communications/thread'
    | '/hub/ic-meetings/artifact'
    | '/hub/ic-meetings/nav-mark'
    | '/hub/ic-meetings/template'
    | '/companies/$id/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CapitalCallsRoute: typeof CapitalCallsRouteWithChildren
  CompaniesRoute: typeof CompaniesRouteWithChildren
  HubRoute: typeof HubRouteWithChildren
  InvestmentsRoute: typeof InvestmentsRoute
  QsbsRoute: typeof QsbsRoute
  RiskFeedRoute: typeof RiskFeedRoute
  SixAlphasRoute: typeof SixAlphasRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capital-calls': {
      id: '/capital-calls'
      path: '/capital-calls'
      fullPath: '/capital-calls'
      preLoaderRoute: typeof CapitalCallsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/companies': {
      id: '/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof CompaniesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/hub': {
      id: '/hub'
      path: '/hub'
      fullPath: '/hub'
      preLoaderRoute: typeof HubRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/investments': {
      id: '/investments'
      path: '/investments'
      fullPath: '/investments'
      preLoaderRoute: typeof InvestmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/qsbs': {
      id: '/qsbs'
      path: '/qsbs'
      fullPath: '/qsbs'
      preLoaderRoute: typeof QsbsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/risk-feed': {
      id: '/risk-feed'
      path: '/risk-feed'
      fullPath: '/risk-feed'
      preLoaderRoute: typeof RiskFeedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/six-alphas': {
      id: '/six-alphas'
      path: '/six-alphas'
      fullPath: '/six-alphas'
      preLoaderRoute: typeof SixAlphasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/capital-calls/$callId': {
      id: '/capital-calls/$callId'
      path: '/$callId'
      fullPath: '/capital-calls/$callId'
      preLoaderRoute: typeof CapitalCallsCallIdRouteImport
      parentRoute: typeof CapitalCallsRoute
    }
    '/companies/': {
      id: '/companies/'
      path: '/'
      fullPath: '/companies/'
      preLoaderRoute: typeof CompaniesIndexRouteImport
      parentRoute: typeof CompaniesRoute
    }
    '/hub/': {
      id: '/hub/'
      path: '/'
      fullPath: '/hub/'
      preLoaderRoute: typeof HubIndexRouteImport
      parentRoute: typeof HubRoute
    }
    '/hub/communications': {
      id: '/hub/communications'
      path: '/communications'
      fullPath: '/hub/communications'
      preLoaderRoute: typeof HubCommunicationsRouteImport
      parentRoute: typeof HubRoute
    }
    '/hub/documents': {
      id: '/hub/documents'
      path: '/documents'
      fullPath: '/hub/documents'
      preLoaderRoute: typeof HubDocumentsRouteImport
      parentRoute: typeof HubRoute
    }
    '/hub/ic-meetings': {
      id: '/hub/ic-meetings'
      path: '/ic-meetings'
      fullPath: '/hub/ic-meetings'
      preLoaderRoute: typeof HubIcMeetingsRouteImport
      parentRoute: typeof HubRoute
    }
    '/hub/tax-documents': {
      id: '/hub/tax-documents'
      path: '/tax-documents'
      fullPath: '/hub/tax-documents'
      preLoaderRoute: typeof HubTaxDocumentsRouteImport
      parentRoute: typeof HubRoute
    }
    '/companies/$id/': {
      id: '/companies/$id/'
      path: '/$id'
      fullPath: '/companies/$id/'
      preLoaderRoute: typeof CompaniesIdIndexRouteImport
      parentRoute: typeof CompaniesRoute
    }
    '/companies/$id/budget': {
      id: '/companies/$id/budget'
      path: '/$id/budget'
      fullPath: '/companies/$id/budget'
      preLoaderRoute: typeof CompaniesIdBudgetRouteImport
      parentRoute: typeof CompaniesRoute
    }
    '/companies/$id/milestones': {
      id: '/companies/$id/milestones'
      path: '/$id/milestones'
      fullPath: '/companies/$id/milestones'
      preLoaderRoute: typeof CompaniesIdMilestonesRouteImport
      parentRoute: typeof CompaniesRoute
    }
    '/companies/$id/qsbs': {
      id: '/companies/$id/qsbs'
      path: '/$id/qsbs'
      fullPath: '/companies/$id/qsbs'
      preLoaderRoute: typeof CompaniesIdQsbsRouteImport
      parentRoute: typeof CompaniesRoute
    }
    '/hub/communications/session': {
      id: '/hub/communications/session'
      path: '/session'
      fullPath: '/hub/communications/session'
      preLoaderRoute: typeof HubCommunicationsSessionRouteImport
      parentRoute: typeof HubCommunicationsRoute
    }
    '/hub/communications/synthesis': {
      id: '/hub/communications/synthesis'
      path: '/synthesis'
      fullPath: '/hub/communications/synthesis'
      preLoaderRoute: typeof HubCommunicationsSynthesisRouteImport
      parentRoute: typeof HubCommunicationsRoute
    }
    '/hub/communications/thread': {
      id: '/hub/communications/thread'
      path: '/thread'
      fullPath: '/hub/communications/thread'
      preLoaderRoute: typeof HubCommunicationsThreadRouteImport
      parentRoute: typeof HubCommunicationsRoute
    }
    '/hub/ic-meetings/artifact': {
      id: '/hub/ic-meetings/artifact'
      path: '/artifact'
      fullPath: '/hub/ic-meetings/artifact'
      preLoaderRoute: typeof HubIcMeetingsArtifactRouteImport
      parentRoute: typeof HubIcMeetingsRoute
    }
    '/hub/ic-meetings/nav-mark': {
      id: '/hub/ic-meetings/nav-mark'
      path: '/nav-mark'
      fullPath: '/hub/ic-meetings/nav-mark'
      preLoaderRoute: typeof HubIcMeetingsNavMarkRouteImport
      parentRoute: typeof HubIcMeetingsRoute
    }
    '/hub/ic-meetings/template': {
      id: '/hub/ic-meetings/template'
      path: '/template'
      fullPath: '/hub/ic-meetings/template'
      preLoaderRoute: typeof HubIcMeetingsTemplateRouteImport
      parentRoute: typeof HubIcMeetingsRoute
    }
  }
}

interface CapitalCallsRouteChildren {
  CapitalCallsCallIdRoute: typeof CapitalCallsCallIdRoute
}

const CapitalCallsRouteChildren: CapitalCallsRouteChildren = {
  CapitalCallsCallIdRoute: CapitalCallsCallIdRoute,
}

const CapitalCallsRouteWithChildren = CapitalCallsRoute._addFileChildren(
  CapitalCallsRouteChildren,
)

interface CompaniesRouteChildren {
  CompaniesIndexRoute: typeof CompaniesIndexRoute
  CompaniesIdBudgetRoute: typeof CompaniesIdBudgetRoute
  CompaniesIdMilestonesRoute: typeof CompaniesIdMilestonesRoute
  CompaniesIdQsbsRoute: typeof CompaniesIdQsbsRoute
  CompaniesIdIndexRoute: typeof CompaniesIdIndexRoute
}

const CompaniesRouteChildren: CompaniesRouteChildren = {
  CompaniesIndexRoute: CompaniesIndexRoute,
  CompaniesIdBudgetRoute: CompaniesIdBudgetRoute,
  CompaniesIdMilestonesRoute: CompaniesIdMilestonesRoute,
  CompaniesIdQsbsRoute: CompaniesIdQsbsRoute,
  CompaniesIdIndexRoute: CompaniesIdIndexRoute,
}

const CompaniesRouteWithChildren = CompaniesRoute._addFileChildren(
  CompaniesRouteChildren,
)

interface HubCommunicationsRouteChildren {
  HubCommunicationsSessionRoute: typeof HubCommunicationsSessionRoute
  HubCommunicationsSynthesisRoute: typeof HubCommunicationsSynthesisRoute
  HubCommunicationsThreadRoute: typeof HubCommunicationsThreadRoute
}

const HubCommunicationsRouteChildren: HubCommunicationsRouteChildren = {
  HubCommunicationsSessionRoute: HubCommunicationsSessionRoute,
  HubCommunicationsSynthesisRoute: HubCommunicationsSynthesisRoute,
  HubCommunicationsThreadRoute: HubCommunicationsThreadRoute,
}

const HubCommunicationsRouteWithChildren =
  HubCommunicationsRoute._addFileChildren(HubCommunicationsRouteChildren)

interface HubIcMeetingsRouteChildren {
  HubIcMeetingsArtifactRoute: typeof HubIcMeetingsArtifactRoute
  HubIcMeetingsNavMarkRoute: typeof HubIcMeetingsNavMarkRoute
  HubIcMeetingsTemplateRoute: typeof HubIcMeetingsTemplateRoute
}

const HubIcMeetingsRouteChildren: HubIcMeetingsRouteChildren = {
  HubIcMeetingsArtifactRoute: HubIcMeetingsArtifactRoute,
  HubIcMeetingsNavMarkRoute: HubIcMeetingsNavMarkRoute,
  HubIcMeetingsTemplateRoute: HubIcMeetingsTemplateRoute,
}

const HubIcMeetingsRouteWithChildren = HubIcMeetingsRoute._addFileChildren(
  HubIcMeetingsRouteChildren,
)

interface HubRouteChildren {
  HubCommunicationsRoute: typeof HubCommunicationsRouteWithChildren
  HubDocumentsRoute: typeof HubDocumentsRoute
  HubIcMeetingsRoute: typeof HubIcMeetingsRouteWithChildren
  HubTaxDocumentsRoute: typeof HubTaxDocumentsRoute
  HubIndexRoute: typeof HubIndexRoute
}

const HubRouteChildren: HubRouteChildren = {
  HubCommunicationsRoute: HubCommunicationsRouteWithChildren,
  HubDocumentsRoute: HubDocumentsRoute,
  HubIcMeetingsRoute: HubIcMeetingsRouteWithChildren,
  HubTaxDocumentsRoute: HubTaxDocumentsRoute,
  HubIndexRoute: HubIndexRoute,
}

const HubRouteWithChildren = HubRoute._addFileChildren(HubRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CapitalCallsRoute: CapitalCallsRouteWithChildren,
  CompaniesRoute: CompaniesRouteWithChildren,
  HubRoute: HubRouteWithChildren,
  InvestmentsRoute: InvestmentsRoute,
  QsbsRoute: QsbsRoute,
  RiskFeedRoute: RiskFeedRoute,
  SixAlphasRoute: SixAlphasRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
